import { useEffect, useState, useCallback } from "react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { EmployeesTab } from "@/components/payroll/EmployeesTab";
import { MonthlyTab } from "@/components/payroll/MonthlyTab";
import { FinalTab } from "@/components/payroll/FinalTab";
import { BpjsSettingsDialog } from "@/components/payroll/BpjsSettingsDialog";
import { MONTHS } from "@/components/payroll/dl";

export default function Payroll() {
  const { selectedClientId, clients } = useAuth();
  const { t } = useI18n();
  const clientId = selectedClientId;
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [employees, setEmployees] = useState([]);
  const loadEmp = useCallback(async () => {
    if (!clientId) return;
    const { data } = await api.get(`/employees?client_id=${clientId}`);
    setEmployees(data);
  }, [clientId]);
  useEffect(() => { loadEmp(); }, [loadEmp]);
  const clientName = clients.find((c) => c.id === clientId)?.name || "";
  const years = Array.from({ length: 5 }, (_, i) => now.getFullYear() + 1 - i);

  if (!clientId) return <Card className="p-8 text-center text-muted-foreground" data-testid="payroll-no-client">Pilih klien terlebih dahulu di header.</Card>;

  return (
    <div className="space-y-4" data-testid="payroll-page">
      <div className="page-sticky flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-head text-2xl font-bold tracking-tight">{t("payroll.title")}</h1>
          <p className="text-sm text-muted-foreground mt-1">PPh 21 TER bulanan · Masa Desember & resign dihitung ulang dengan Pasal 17 {clientName && `· ${clientName}`}</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <Select value={String(month)} onValueChange={(v) => setMonth(Number(v))}>
            <SelectTrigger className="w-36" data-testid="payroll-month"><SelectValue /></SelectTrigger>
            <SelectContent>{MONTHS.map((m, i) => <SelectItem key={i} value={String(i + 1)}>{m}</SelectItem>)}</SelectContent>
          </Select>
          <Select value={String(year)} onValueChange={(v) => setYear(Number(v))}>
            <SelectTrigger className="w-24" data-testid="payroll-year"><SelectValue /></SelectTrigger>
            <SelectContent>{years.map((y) => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}</SelectContent>
          </Select>
          <BpjsSettingsDialog clientId={clientId} />
        </div>
      </div>
      <Tabs defaultValue="monthly">
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="employees" data-testid="tab-employees">Master Karyawan</TabsTrigger>
          <TabsTrigger value="monthly" data-testid="tab-payroll-monthly">Transaksi PPh 21 Bulanan</TabsTrigger>
          <TabsTrigger value="final" data-testid="tab-payroll-final">Kalkulasi Akhir (A1)</TabsTrigger>
        </TabsList>
        <TabsContent value="employees"><EmployeesTab clientId={clientId} employees={employees} reload={loadEmp} /></TabsContent>
        <TabsContent value="monthly"><MonthlyTab clientId={clientId} employees={employees} year={year} month={month} reloadEmp={loadEmp} /></TabsContent>
        <TabsContent value="final"><FinalTab clientId={clientId} year={year} /></TabsContent>
      </Tabs>
    </div>
  );
}
